import { render } from "./ProcessComponent.vue?vue&type=template&id=3580fc3e"
import script from "./ProcessComponent.vue?vue&type=script&lang=js"
export * from "./ProcessComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__